import { ActionIcon, AppShell, Aside, Group, Navbar, ScrollArea } from '@mantine/core';
import { useContext, useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { IconChevronsLeft, IconChevronsRight } from '@tabler/icons';
import DoubleNavbar from '../../Molecules/DoubleNavbar';
import { WindowContext } from '../../Service/Context/WindowContext';
import PageHeader from '../../Templates/Navigation/PageHeader';
import { ResourceDetailsContextProvider } from '../../Service/Context/ResourceDetailsContext';
import BookitupFooter from '../../Templates/Navigation/phone/BookitupFooter';
import ResourceDetailsPageFooter from '../../Templates/Navigation/phone/ResourceDetailsFooter';
import ResourceNavBar from './ResourceNavBar';
import ResourceAsideBar from './aside/ResourceAsideBar';

const ResourcePage = () => {
  const { sm, md } = useContext(WindowContext);
  const [navBarOpen, setNavBarOpen] = useState(false);
  const [asideBarOpen, setAsideBarOpen] = useState(false);
  const [asideBarCollapsed, setAsideBarCollapsed] = useState(md);

  useEffect(() => {
    document.title = 'Ressource';
  }, []);

  useEffect(() => {
    if (navBarOpen && asideBarOpen) {
      setAsideBarOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navBarOpen]);

  return (
    <ResourceDetailsContextProvider>
      <AppShell
        header={<PageHeader />}
        navbar={
          <div>
            {sm ? (
              <Navbar hiddenBreakpoint="sm" hidden={!navBarOpen} width={{ sm: 220, md: 250 }}>
                <ScrollArea>
                  <ResourceNavBar closeNavBar={() => setNavBarOpen(false)} />
                </ScrollArea>
              </Navbar>
            ) : (
              <DoubleNavbar>
                <ResourceNavBar closeNavBar={() => setNavBarOpen(false)} />
              </DoubleNavbar>
            )}
          </div>
        }
        aside={
          // eslint-disable-next-line react/jsx-no-useless-fragment
          <>
            {(!sm || asideBarOpen) && (
              <Aside
                p="md"
                hiddenBreakpoint="md"
                width={{ sm: asideBarCollapsed ? 60 : 275, lg: asideBarCollapsed ? 60 : 350 }}
                sx={{ overflow: 'auto' }}
              >
                {!sm && (
                  <div style={{ cursor: 'pointer' }}>
                    {asideBarCollapsed ? (
                      <IconChevronsLeft onClick={() => setAsideBarCollapsed(false)} style={{ cursor: 'pointer' }} />
                    ) : (
                      <Group position="right" mb={10}>
                        <IconChevronsRight onClick={() => setAsideBarCollapsed(true)} style={{ cursor: 'pointer' }} />
                      </Group>
                    )}
                  </div>
                )}
                {(!asideBarCollapsed || asideBarOpen) && <ResourceAsideBar />}
              </Aside>
            )}
          </>
        }
        styles={(theme) => ({
          main: { backgroundColor: theme.colorScheme === 'dark' ? theme.colors.dark[8] : theme.colors.gray[0] },
        })}
        footer={
          sm ? (
            <BookitupFooter>
              <ResourceDetailsPageFooter
                asideBarOpen={asideBarOpen}
                toggleAsideBar={() => setAsideBarOpen(!asideBarOpen)}
              />
            </BookitupFooter>
          ) : undefined
        }
      >
        <Outlet />
      </AppShell>
    </ResourceDetailsContextProvider>
  );
};

export default ResourcePage;
